module.exports = __webpack_public_path__ + "img/news2-2.00a71640.png";